import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import { CONTRACT_TYPES } from '../../../constants/contract-types';
import { FILE_FORMATS, FILE_FORMAT_LABELS } from '../../../constants/file-formats';
import useGetUser from '../../../hooks/useGetUser';
import userHasPermission from '../../../helpers/permissions';
import CONTRACT_INPUT_LABEL_PROPS from './contractInputLabelProps';

const FileFormatInput = ({ input, obj, handleInfoFunc }) => {
  const user = useGetUser();
  const canChangeFormat = userHasPermission(user, 'customers.change_companyframeworkcontractrequest');

  const getForcedFormat = () => {
    if (obj.contractType === CONTRACT_TYPES.NOTARY) {
      return FILE_FORMATS.DOCX;
    }
    if (obj.contractType === CONTRACT_TYPES.DIGITAL && !canChangeFormat) {
      return FILE_FORMATS.PDF;
    }
    return null;
  };

  const forcedFormat = getForcedFormat();

  useEffect(() => {
    if (forcedFormat && obj[input.id] !== forcedFormat) {
      handleInfoFunc(input.id, forcedFormat, obj.id);
    }
  }, [forcedFormat, obj[input.id], obj.contractType]);

  const isDisabled = input.disabled
    || (obj.contractType === CONTRACT_TYPES.DIGITAL && !canChangeFormat)
    || obj.contractType === CONTRACT_TYPES.NOTARY;

  return (
    <TextField
      select
      sx={input.sx}
      id={input.id}
      label={input.label}
      disabled={isDisabled}
      value={obj[input.id] || (obj.contractType === CONTRACT_TYPES.NOTARY ? FILE_FORMATS.DOCX : FILE_FORMATS.PDF)}
      onChange={(e) => handleInfoFunc(input.id, e.target.value, obj.id)}
      SelectProps={{ className: input.selectClassName }}
      InputLabelProps={CONTRACT_INPUT_LABEL_PROPS}
    >
      <MenuItem value={FILE_FORMATS.PDF}>{FILE_FORMAT_LABELS[FILE_FORMATS.PDF]}</MenuItem>
      <MenuItem value={FILE_FORMATS.DOCX}>{FILE_FORMAT_LABELS[FILE_FORMATS.DOCX]}</MenuItem>
    </TextField>
  );
};

FileFormatInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    selectClassName: PropTypes.string,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default FileFormatInput;
